import React from "react";
import Flex from "../Flex";

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 16 | 18 | 20 | 22 | number} [props.spacing=4] - Space between items (in tailwind spacing units)
 * @param {React.ReactElement} [props.divider] - Element to be placed between items
 * @param {boolean} [props.wrap=false] - Whether items can wrap to next line
 * @param {"stretch" | "flex-start" | "flex-end" | "center" | "baseline"} [props.align="center"] - Vertical alignment of items
 * @param {"flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly"} [props.justify] - Horizontal distribution of items
 * @param {string} [props.className] - Additional classes
 * @returns {JSX.Element}
 */
const HStack = ({ children, spacing = 4, divider, align = "center", justify, wrap = false, className, ...props }) => {
  // If there's a divider, wrap children with it
  const wrappedChildren = React.Children.toArray(children).reduce((acc, child, index, array) => {
    if (index === array.length - 1) return [...acc, child];
    return [...acc, child, React.cloneElement(divider || React.Fragment, { key: `divider-${index}` })];
  }, []);

  return (
    <Flex
      direction="row"
      align={align}
      justify={justify}
      wrap={wrap ? "wrap" : "nowrap"}
      className={className}
      style={{
        gap: typeof spacing === "number" ? spacing * 4 : undefined,
        ...props.style,
      }}
      {...props}
    >
      {divider ? wrappedChildren : children}
    </Flex>
  );
};

export default HStack;
